// extracted by mini-css-extract-plugin
export const row = "fact-module--row--1-l4k";
export const column = "fact-module--column--2QfuV";
export const value = "fact-module--value--19N9x";